import React, {useEffect} from 'react';
import {useLocation , useParams} from "react-router-dom";
import {gql, useQuery} from "@apollo/client";
import {CATEGORY_FRAGMENT, RESTAURANT_FRAGMENT} from "../../fragments";
import {category, categoryVariables} from "../../__generated__/category";
import {Helmet} from "react-helmet-async";

const CATEGORY_QUERY = gql`
    query category($input: CategoryInput!) {
        category(input: $input) {
            ok
            error
            totalPages
            totalResults
            restaurants {
                ...RestaurantParts
            }
            category {
                ...CategoryParts
            }
        }
    }
    ${RESTAURANT_FRAGMENT}
    ${CATEGORY_FRAGMENT}
`;


interface ICategoryParams{
    slug : string;
}

export const Category = () => {

    const params = useParams<ICategoryParams>();

    const {data, loading} = useQuery<category, categoryVariables>(CATEGORY_QUERY, {
        variables: {
            input: {
                page: 1,
                slug: params.slug
            }
        }
    });

    console.log(data);

    return (
        <div>
            <Helmet>
                <title>{data?.category.category?.name ? `${data?.category.category?.name} | Category` : "Category"}</title>
            </Helmet>
            <span>Category</span>
        </div>

    )
}